import PropTypes from 'prop-types';

export const CustomGroupPropTypes = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string.isRequired,
  publicFlag: PropTypes.bool.isRequired,
  allowEditFlag: PropTypes.bool.isRequired,
  groupItem: PropTypes.arrayOf(PropTypes.shape({
    itemName: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
  })).isRequired,
  createdBy: PropTypes.string,
  updatedBy: PropTypes.string,
});

export const CustomGroupsPropTypes = PropTypes.arrayOf(CustomGroupPropTypes).isRequired;
